/* eslint-disable max-len */
import React from 'react';
function ComposeOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M14.0833 3V4.5295H4.58333V20.5481H20.4373V10.9167H22V20.4705C22 21.312 21.2875 22 20.4167 22H4.58333C3.7125 22 3 21.312 3 20.4705V4.5295C3 3.68796 3.7125 3 4.58333 3H14.0833ZM17.6872 5H17.767C17.9271 5.00954 18.0845 5.07564 18.2078 5.19762L19.8024 6.79216C19.9237 6.91278 19.9898 7.06882 20 7.22692V7.31755C19.9898 7.47632 19.9237 7.63169 19.8024 7.75298L18.5554 9L16 6.44463L17.247 5.19762C17.3697 5.07564 17.5278 5.00954 17.6872 5ZM7 15.2147L15.2155 7L18 9.78602L9.78528 18H7V15.2147Z" })));
}
export default ComposeOutlined;
